/* eslint-disable max-len */
import { Component, OnInit } from '@angular/core';
import {
  Platform,
  LoadingController,
  ModalController,
  AlertController,
  ToastController,
  ActionSheetController,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
  IonContent,
  IonList,
  IonItem,
  IonAvatar,
  IonIcon,
  IonLabel,
  IonButton,
  IonInput,
  IonText,
  IonTextarea,
  IonRadioGroup,
  IonRadio,
  IonNote,
  IonRow,
  IonFab,
  IonFabButton,
  IonFabList,
  IonFooter,
} from '@ionic/angular/standalone';
import { Storage } from '@ionic/storage';
import { GroupServices } from '../../../providers/group-services';
import { FileServices } from '../../../providers/files-provider';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { environment, common } from '../../../../environments/environment';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { EmailServices } from '../../../providers/email-services';
import { AgentsService } from '../../../providers/crm-agent-provider';
import { GoogleAnalyticsService } from 'src/app/providers/google-analytics.service';
import { GlobalDataService } from 'src/app/providers/global-data.service';
import { MessagingServicesProvider } from 'src/app/providers/messaging-services';
import { ActivatedRoute, Router } from '@angular/router';
//import {ContactAgentPage } from '../contact-agent/contact-agent';
//import {MessageConversationPage} from '../message-conversation/message-conversation';
//import {MessagingServicesProvider} from "../../providers/messaging-services";
import { AdsServicesService } from '../../../providers/ads-services.service';
import { addIcons } from 'ionicons';
import {
  thumbsDown,
  thumbsUp,
  people,
  heart,
  mail,
  star,
  starOutline,
  addCircle,
  alert,
  settings,
  logOut,
  add,
  personAdd,
  trash,
} from 'ionicons/icons';
import { NgIf, NgFor, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-club-members',
  templateUrl: './club-members.page.html',
  styleUrls: ['./club-members.page.scss'],
  standalone: true,
  imports: [
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonContent,
    IonList,
    IonItem,
    IonAvatar,
    NgIf,
    IonIcon,
    IonLabel,
    IonButton,
    IonInput,
    FormsModule,
    IonText,
    IonTextarea,
    IonRadioGroup,
    IonRadio,
    NgFor,
    IonNote,
    IonRow,
    IonFab,
    IonFabButton,
    IonFabList,
    IonFooter,
    TranslatePipe,
    CommonModule,
  ],
})
export class ClubMembersPage implements OnInit {
  //myPhoto:any;
  //error:any;
  //public base64Image: string;

  targetAgent: string;
  agentName: string;
  groupDetails: any;
  groupMembers: any;
  totalMembers: number;
  findMemberStatus: number;
  findMemberAgentId: string;
  agentId: string;
  agent: any;
  userEmail: string;
  public base64Image: string;
  myPhoto: any;
  error: any;
  targetEmail: string;
  targetName: string;
  language: number;
  inGroup: boolean;
  actionSheet: any;
  debounceTimeout: any;
  debounceReady: boolean = false;
  collectionDetails: any;

  constructor(
    private platform: Platform,
    private toastCtrl: ToastController,
    public loading: LoadingController,
    private modalCtrl: ModalController,
    private messageServices: MessagingServicesProvider,
    private groupServices: GroupServices,
    private fileServices: FileServices,
    private gds: GlobalDataService,
    private ads: AdsServicesService,
    //              private messageServices : MessagingServicesProvider,
    private actionSheetCtrl: ActionSheetController,
    public translate: TranslateService,
    public alertCtrl: AlertController,
    private emailService: EmailServices,
    private agentsService: AgentsService,
    private gaService: GoogleAnalyticsService,
    public localStorage: Storage,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    void this.gaService.trackPageView('group_members_page');

    this.gds.getConversationId().subscribe((conversationId) => {
      console.log('Triggering Conversation reset on club-members-page');
      if (conversationId === this.groupDetails.group_message_conversation_id) {
        this.groupDetails.last_read_message_in_group =
          this.groupDetails.max_message_in_group;
      }
    });
    addIcons({
      thumbsDown,
      thumbsUp,
      people,
      heart,
      mail,
      star,
      starOutline,
      addCircle,
      alert,
      settings,
      logOut,
      add,
      personAdd,
      trash,
    });
  }

  ngOnInit() {
    console.log('#########################');
    console.log('Entering ngOnInit');
    console.log('#########################');
    //    this.loadData();
    this.groupDetails = { Group_name: '' };
    this.gds.getAgent().subscribe((data) => {
      console.log('receiving agent data from GDS');
      console.log('agent is:');
      console.log(data);
      if (data !== undefined && data !== null) {
        this.agent = data;
        this.agentId = data.AGENT_ID;
        this.userEmail = data.EMAIL;
        this.language = data.LANGUAGE_ID;
        this.agentName = data.FIRST_NAME + ' ' + data.LAST_NAME;
      }
    });
    console.log('#########################');
    console.log('Exiting ngOnInit');
    console.log('#########################');
  }

  ionViewDidEnter() {
    console.log('#########################');
    console.log('Entering ionViewWillEnter');
    console.log('#########################');
    this.loadData();
    console.log('#########################');
    console.log('Exiting ionViewWillEnter');
    console.log('#########################');
  }

  loadData() {
    console.log('#########################');
    console.log('Entering loadData');
    console.log('#########################');
    //    let obj: any = this.activatedRoute.snapshot.params;
    // Allow groupDetails to be muttable
    //    this.groupDetails = JSON.parse(JSON.stringify(obj));
    //    console.log("Group is:")
    //    console.log(this.groupDetails);

    console.log(this.activatedRoute.snapshot.params);
    this.collectionDetails = this.activatedRoute.snapshot.params;
    console.log(this.collectionDetails.user_col_id);

    this.gds.getActiveClub().subscribe(async (data) => {
      console.log(data);

      if (data) {
        console.log(data.group);

        this.groupDetails = data.group;

        console.log(this.groupDetails.STATUS);

        if (this.agentId === undefined) {
          this.agentId = this.groupDetails.agent_id;
        }
        this.getGroupMembers();
      } else {
        if (this.agentId) {
          console.log('agentId pathway');

          try {
            const data: any = await this.groupServices.getGroupById(
              this.agentId,
              this.collectionDetails.id
            );
            console.log('got group by id');
            console.log(data);
            console.log(data.resource[0]);
            if (data.resource[0]) {
              this.groupDetails = data.resource[0];
              this.groupDetails.STATUS = +data.resource[0].membership_status;

              console.log(+this.groupDetails.STATUS);

              if (this.agentId === undefined) {
                this.agentId = this.groupDetails.agent_id;
              }
              this.getGroupMembers();
              // } else {
              //   this.groupServices
              //     .getUserGroup(this.agentId, this.collectionDetails.id)
              //     .subscribe((data: any) => {
              //       console.log(data);
              //       console.log(data.resource[0]);
              //       if (data.resource[0]) {
              //         this.groupDetails = data.resource[0];

              //         console.log(+this.groupDetails.STATUS);

              //         if (this.agentId === undefined) {
              //           this.agentId = this.groupDetails.agent_id;
              //         }
              //         this.getGroupMembers();
              //       }
              //     });
            } else {
              this.router.navigate(['clubs']);
            }
          } catch (error) {
            this.router.navigate(['clubs']);
          }
        } else {
          this.gds.getAgent().subscribe(async (data) => {
            console.log('receiving agent data from GDS');
            console.log('agent is:');
            console.log(data);
            if (data !== undefined && data !== null) {
              this.agent = data;
              this.agentId = data.AGENT_ID;
              this.userEmail = data.EMAIL;
              this.language = data.LANGUAGE_ID;
              this.agentName = data.FIRST_NAME + ' ' + data.LAST_NAME;
            }

            try {
              const data: any = await this.groupServices.getGroupById(
                this.agentId,
                this.collectionDetails.id
              );
              console.log('got group by id');

              console.log(data);
              if (data.resource[0]) {
                this.groupDetails = data.resource[0];
                this.groupDetails.STATUS = +data.resource[0].membership_status;

                console.log(+this.groupDetails.STATUS);

                if (this.agentId === undefined) {
                  this.agentId = this.groupDetails.agent_id;
                }
                this.getGroupMembers();
                // } else {
                //   this.groupServices
                //     .getUserGroup(this.agentId, this.collectionDetails.id)
                //     .subscribe((data: any) => {
                //       console.log(data);
                //       console.log(data.resource[0]);
                //       if (data.resource[0]) {
                //         this.groupDetails = data.resource[0];

                //         console.log(+this.groupDetails.STATUS);

                //         if (this.agentId === undefined) {
                //           this.agentId = this.groupDetails.agent_id;
                //         }
                //         this.getGroupMembers();
                //       }
                //     });
              } else {
                this.router.navigate(['clubs']);
              }
            } catch (error) {
              console.error('No active group found on GDS');
              this.router.navigate(['clubs']);
            }
          });
        }
      }
    });
  }

  //getGroupMembers() {
  //  console.log('Entering getGroupMembers');
  //  this.groupServices.getGroupMembers(this.groupDetails.group_id, this.agentId.toString())
  //    .subscribe( (groupMembers: any)=> {
  //                this.groupMembers = groupMembers.resource;
  //                console.log(this.groupMembers);
  //                this.totalMembers = this.groupMembers.length;
  //                this.inGroup = false;
  //                for ( const member of this.groupMembers){
  //                  // correct AVATAR
  //                  console.log(member.CRM_AGENT_by_AGENT_ID);
  //                  let newAvatar = '';
  //                  if (member.CRM_AGENT_by_AGENT_ID==null){
  //                    newAvatar='https://ui-avatars.com/api/?background=204F61&color=fff&font-size=0.4&name='+member.email.replace(' ','+');
  //                  }
  //                  else {
  //                    newAvatar='https://ui-avatars.com/api/?background=204F61&color=fff&font-size=0.4&name='+(member.CRM_AGENT_by_AGENT_ID.FIRST_NAME+ ' '+ member.CRM_AGENT_by_AGENT_ID.LAST_NAME).replace(' ','+');
  //                  }
  //                  if (member.CRM_AGENT_by_AGENT_ID == null || member.CRM_AGENT_by_AGENT_ID.AVATAR == null){
  //                    console.log('AMPM 20180414 - Fixing');
  //                    if (member.CRM_AGENT_by_AGENT_ID == null) {
  //                      member.CRM_AGENT_by_AGENT_ID={AVATAR:newAvatar};
  //                      console.log('AMPM 20180414 - setting Avatar');
  //                    } else {
  //                      member.CRM_AGENT_by_AGENT_ID.AVATAR=newAvatar;
  //                    }
  //                  }
  //                  if (member.AGENT_ID === this.agentId && member.STATUS >0 && this.inGroup === false) {
  //                    this.inGroup = true;
  //                  }
  //                }
  //                console.log('InGroup = '+ this.inGroup);
  //                },
  //                (error)=> console.log(error));
  //}

  //getGroupMembers() {
  //  console.log('Entering getGroupMembers');
  //  this.groupServices.getGroupMembers(this.groupDetails.group_id, this.agentId.toString())
  //    .subscribe( (groupMembers: any)=> {
  //                this.groupMembers = groupMembers.resource;
  //                console.log(this.groupMembers);
  //                this.totalMembers = this.groupMembers.length;
  //                this.inGroup = false;
  //                for ( const member of this.groupMembers){
  //                  // correct AVATAR
  //                  console.log(member.CRM_AGENT_by_AGENT_ID);
  //                  let newAvatar = '';
  //                  if (member.CRM_AGENT_by_AGENT_ID==null){
  //                    newAvatar='https://ui-avatars.com/api/?background=204F61&color=fff&font-size=0.4&name='+member.email.replace(' ','+');
  //                  }
  //                  else {
  //                    newAvatar='https://ui-avatars.com/api/?background=204F61&color=fff&font-size=0.4&name='+(member.CRM_AGENT_by_AGENT_ID.FIRST_NAME+ ' '+ member.CRM_AGENT_by_AGENT_ID.LAST_NAME).replace(' ','+');
  //                  }
  //                  if (member.CRM_AGENT_by_AGENT_ID == null || member.CRM_AGENT_by_AGENT_ID.AVATAR == null){
  //                    console.log('AMPM 20180414 - Fixing');
  //                    if (member.CRM_AGENT_by_AGENT_ID == null) {
  //                      member.CRM_AGENT_by_AGENT_ID={AVATAR:newAvatar};
  //                      console.log('AMPM 20180414 - setting Avatar');
  //                    } else {
  //                      member.CRM_AGENT_by_AGENT_ID.AVATAR=newAvatar;
  //                    }
  //                  }
  //                  if (member.AGENT_ID === this.agentId && member.STATUS >0 && this.inGroup === false) {
  //                    this.inGroup = true;
  //                  }
  //                }
  //                console.log('InGroup = '+ this.inGroup);
  //                },
  //                (error)=> console.log(error));
  //}

  async getGroupMembers() {
    console.log('Entering getGroupMembers');
    if (this.groupDetails) {
      try {
        const groupMembers: any = await this.groupServices.getGroupMembers(
          this.groupDetails.group_id,
          this.agentId.toString()
        );
        this.groupMembers = groupMembers.resource;
        console.log(this.groupMembers);
        this.totalMembers = this.groupMembers.length;
        this.inGroup = false;
        for (const member of this.groupMembers) {
          // correct AVATAR
          console.log(member.CRM_AGENT_by_AGENT_ID);
          let newAvatar = '';
          if (member.CRM_AGENT_by_AGENT_ID == null) {
            newAvatar =
              'https://ui-avatars.com/api/?background=204F61&color=fff&font-size=0.4&name=' +
              member.email.replace(' ', '+');
          } else {
            newAvatar =
              'https://ui-avatars.com/api/?background=204F61&color=fff&font-size=0.4&name=' +
              (
                member.CRM_AGENT_by_AGENT_ID.FIRST_NAME +
                ' ' +
                member.CRM_AGENT_by_AGENT_ID.LAST_NAME
              ).replace(' ', '+');
          }
          if (
            member.CRM_AGENT_by_AGENT_ID == null ||
            member.CRM_AGENT_by_AGENT_ID.AVATAR == null
          ) {
            console.log('AMPM 20180414 - Fixing');
            if (member.CRM_AGENT_by_AGENT_ID == null) {
              member.CRM_AGENT_by_AGENT_ID = { AVATAR: newAvatar };
              console.log('AMPM 20180414 - setting Avatar');
            } else {
              member.CRM_AGENT_by_AGENT_ID.AVATAR = newAvatar;
            }
          }
          if (
            member.AGENT_ID === this.agentId &&
            member.STATUS > 0 &&
            this.inGroup === false
          ) {
            this.inGroup = true;
          }
        }
        console.log('InGroup = ' + this.inGroup);
      } catch (error) {
        console.log(error);
      }
    }
  }

  async saveClubChanges(groupId) {
    if (this.isUserInternal(this.userEmail)) {
      const alrt = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant(
          'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
        ),
        buttons: [this.translate.instant('CONTINUE')],
      });
      alrt.present();
      return;
    }
    console.log('Group details ' + JSON.stringify(this.groupDetails));

    //this.groupServices.updateGroup(this.agentId.toString(),this.groupDetails.group_id, this.groupDetails.group_type,
    //  this.groupDetails.Group_name, this.groupDetails.GROUP_DESCRIPTION)
    //    .subscribe( ()=> {
    //      if (this.platform.is('cordova')) {
    //        this.ga.trackEvent('group_members_page', 'save_club', 'success', 1).then(() => {});
    //      }
    //      this.ads.evtShowInterstitialAdd('G');
    //
    //      this.presentToast(this.translate.instant('CLUB_UPDATED_SUCCESSFULLY'), false, "primary");
    //    },
    //    (error)=> {
    //      if (this.platform.is('cordova')) {
    //        this.ga.trackEvent('group_members_page', 'save_club', 'success', 0).then(() => {});
    //      }
    //      this.presentToast(this.translate.instant('CLUB_UPDATE_FAILED'), false, "exme-red");
    //    }
    //  );

    this.groupServices
      .updateGroup(
        this.agentId.toString(),
        this.groupDetails.group_id,
        this.groupDetails.group_type,
        this.groupDetails.Group_name,
        this.groupDetails.GROUP_DESCRIPTION
      )
      .then(() => {
        console.log('Club updated successfully');

        void this.gaService.trackEvent('group_members_page', 'save_club', 'success', 1);

        this.ads.evtShowInterstitialAdd('G');
        this.presentToast(
          this.translate.instant('CLUB_UPDATED_SUCCESSFULLY'),
          false,
          'primary'
        );
      })
      .catch((error) => {
        console.log('Error updating club:', error);

        void this.gaService.trackEvent('group_members_page', 'save_club', 'failure', 0);

        this.presentToast(
          this.translate.instant('CLUB_UPDATE_FAILED'),
          false,
          'exme-red'
        );
      });
  }

  async checkBeforeInviteSend(
    email: string,
    groupId: number,
    groupName: string
  ) {
    if (this.isUserInternal(email)) {
      const alrt = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant(
          'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
        ),
        buttons: [this.translate.instant('CONTINUE')],
      });
      alrt.present();
      return;
    }
    email = email.trim();
    if (
      email.indexOf(',') > -1 ||
      email.indexOf(' ') > -1 ||
      email.indexOf(';') > -1
    ) {
      const alrt = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant('NO_MULTIPLE_INVITES'),
        buttons: ['OK'],
      });
      alrt.present();
      return;
    }

    this.findMemberStatus = 0;
    console.log('Sending Invite to ' + email);
    for (const member of this.groupMembers) {
      console.log(member);
      if (
        member.CRM_AGENT_by_AGENT_ID !== null &&
        email.toLowerCase() === member.CRM_AGENT_by_AGENT_ID.EMAIL.toLowerCase()
      ) {
        //      if (email.toLowerCase() === member.CRM_AGENT_by_AGENT_ID.EMAIL.toLowerCase()) {
        this.findMemberStatus = member.STATUS;
        this.findMemberAgentId = member.AGENT_ID;
      }
    }

    console.log('Estado do membro...' + this.findMemberStatus);

    if (this.findMemberStatus === 0) {
      //this.groupServices.callInviteMemberToGroup(email, groupId)
      //  .subscribe ( () => { this.getGroupMembers();
      //                       if (this.platform.is('cordova')) {
      //                         this.ga.trackEvent('group_members_page', 'invite_to_club', 'success', 1).then(() => {});
      //                       }
      //                       this.ads.evtShowInterstitialAdd('G');
      //                       this.sendInvitationMail(email,this.agentName , groupName);
      //                     },
      //               (err) => {
      //                 console.log('Erro a enviar convite');
      //                 if (this.platform.is('cordova')) {
      //                   this.ga.trackEvent('group_members_page', 'invite_to_club', 'success', 0).then(() => {});
      //                 }
      //               }
      //             );

      try {
        await this.groupServices.callInviteMemberToGroup(email, groupId);
        this.getGroupMembers();

        void this.gaService.trackEvent('group_members_page', 'invite_to_club', 'success', 1);

        this.ads.evtShowInterstitialAdd('G');
        this.sendInvitationMail(email, this.agentName, groupName);
      } catch (err) {
        console.log('Error sending invite:', err);

        void this.gaService.trackEvent('group_members_page', 'invite_to_club', 'failure', 0);
      }
    }

    if (this.findMemberStatus < 0) {
      if (this.findMemberAgentId !== '') {
        console.log('o user existe');
        this.updateAgentGroupStatus(
          groupId,
          this.findMemberAgentId,
          2,
          'admin'
        );
        this.sendInvitationMail(email, this.agentName, groupName);
      } else {
        this.updateAgentGroupStatusByEmail(groupId, email, 2, 'admin');
        this.sendInvitationMail(email, email, groupName);
      }
    }

    if (this.findMemberStatus > 0) {
      const alert = await this.alertCtrl.create({
        header: this.translate.instant('EMAIL_FROM_MEMBER_TITLE'),
        subHeader: this.translate.instant('EMAIL_FROM_MEMBER_SUBTITLE'),
        buttons: [{ text: 'Ok', role: 'cancel' }],
        cssClass: 'alert-buttons',
      });
      alert.present();
    }
  }

  async checkBeforeInviteSendMultiple(
    email: string,
    groupId: number,
    groupName: string
  ) {
    if (this.isUserInternal(email)) {
      const alrt = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant(
          'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
        ),
        buttons: [this.translate.instant('CONTINUE')],
      });
      alrt.present();
      return;
    }
    if (email.indexOf(';') > -1) {
      const alrt = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant('WRONG_SEPARATOR_JUST_COMMA'),
        buttons: ['OK'],
      });
      alrt.present();
      return;
    }
    const emailLst = email.trim().split(',');
    for (let emailLoc of emailLst) {
      emailLoc = emailLoc.trim();
      this.findMemberStatus = 0;
      console.log('Sending Invite to ' + emailLoc);
      for (const member of this.groupMembers) {
        console.log(member);
        console.log(JSON.stringify(member.CRM_AGENT_by_AGENT_ID));
        if (
          member.CRM_AGENT_by_AGENT_ID !== null &&
          emailLoc.toLowerCase() === member.email.toLowerCase()
        ) {
          //      if (email.toLowerCase() === member.CRM_AGENT_by_AGENT_ID.EMAIL.toLowerCase()) {
          this.findMemberStatus = member.STATUS;
          this.findMemberAgentId = member.AGENT_ID;
        }
      }

      console.log('Estado do membro...' + this.findMemberStatus);

      if (this.findMemberStatus === 0) {
        //this.groupServices.callInviteMemberToGroup(emailLoc, groupId)
        //  .subscribe ( () => { this.getGroupMembers();
        //                       if (this.platform.is('cordova')) {
        //                         this.ga.trackEvent('group_members_page', 'invite_to_club', 'success', 1).then(() => {});
        //                       }
        //                       this.ads.evtShowInterstitialAdd('G');
        //                       this.sendInvitationMail(emailLoc,this.agentName , groupName);
        //                     },
        //               (err) => {
        //                 console.log('Erro a enviar convite');
        //                 if (this.platform.is('cordova')) {
        //                   this.ga.trackEvent('group_members_page', 'invite_to_club', 'success', 0).then(() => {});
        //                 }
        //               }
        //             );

        try {
          await this.groupServices.callInviteMemberToGroup(emailLoc, groupId);
          this.getGroupMembers();

          void this.gaService.trackEvent('group_members_page', 'invite_to_club', 'success', 1);

          this.ads.evtShowInterstitialAdd('G');
          this.sendInvitationMail(emailLoc, this.agentName, groupName);
        } catch (err) {
          console.log('Error sending invite:', err);

          void this.gaService.trackEvent('group_members_page', 'invite_to_club', 'failure', 0);
        }
      }

      if (this.findMemberStatus < 0) {
        if (this.findMemberAgentId !== '') {
          console.log('o user existe');
          this.updateAgentGroupStatus(
            groupId,
            this.findMemberAgentId,
            2,
            'admin'
          );
          this.sendInvitationMail(emailLoc, this.agentName, groupName);
        } else {
          this.updateAgentGroupStatusByEmail(groupId, emailLoc, 2, 'admin');
          this.sendInvitationMail(emailLoc, emailLoc, groupName);
        }
      }
    }

    if (this.findMemberStatus > 0) {
      const alert = await this.alertCtrl.create({
        header: this.translate.instant('EMAIL_FROM_MEMBER_TITLE'),
        subHeader: this.translate.instant('EMAIL_FROM_MEMBER_SUBTITLE'),
        buttons: [{ text: 'Ok', role: 'cancel' }],
        cssClass: 'alert-buttons',
      });
      alert.present();
    }
  }

  async sendMailExpeledFromClub(
    targetEmail: string,
    targetName: string,
    clubName: string
  ) {
    const emailBody = {
      template: this.translate.instant('GROUP_MAIL_TEMPLATE'),
      subject: this.translate.instant('GROUP_EXPELED_MAIL_SUBJECT'),
      to: [
        {
          name: targetName,
          email: targetEmail,
        },
      ],
      contexto: this.translate.instant('GROUP_EXPELED_MAIL_CONTEXT'),
      informacao: this.translate.instant('GROUP_EXPELED_MAIL_INFORMATION'),
      sender: '',
      mensagem: this.translate.instant('GROUP_EXPELED_MAIL_MESSAGE'),
      accao: this.translate.instant('GROUP_EXPELED_MAIL_ACTION'),
    };
    this.agentsService
      .agentAllowsMails(targetEmail, this.agentId.toString())
      .subscribe(async (allowMail) => {
        if (allowMail === true) {
          // this.emailService
          //   .sendEmail(emailBody)
          //   .subscribe((error) => console.log(error));

          try {
            await this.emailService.sendEmail(emailBody);
          } catch (error) {
            console.log(error);
          }
          console.log(emailBody);
          console.log('mail enviado');
        } else {
          const toast = await this.toastCtrl.create({
            message: this.translate.instant(
              'EMAIL_NOT_SENT_DISALLOWED_BY_USER'
            ),
            duration: 3000,
            position: 'bottom',
          });
          toast.present();
        }
      });
  }

  sendMailRequestAccepted(
    targetEmail: string,
    targetName: string,
    senderName: string,
    clubName: string
  ) {
    const emailBody = {
      template: this.translate.instant('GROUP_MAIL_TEMPLATE'),
      subject: this.translate.instant('GROUP_REQ_ACCEPTED_MAIL_SUBJECT'),
      to: [
        {
          name: targetName,
          email: targetEmail,
        },
      ],
      contexto: this.translate.instant('GROUP_REQ_ACCEPTED_MAIL_CONTEXT'),
      informacao: this.translate.instant('GROUP_REQ_ACCEPTED_MAIL_INFORMATION'),
      sender: senderName,
      mensagem: this.translate.instant('GROUP_REQ_ACCEPTED_MAIL_MESSAGE'),
      accao: this.translate.instant('GROUP_REQ_ACCEPTED_MAIL_ACTION'),
    };
    this.agentsService
      .agentAllowsMails(targetEmail, this.agentId.toString())
      .subscribe(async (allowMail) => {
        if (allowMail === true) {
          // this.emailService
          //   .sendEmail(emailBody)
          //   .subscribe((error) => console.log(error));

          try {
            await this.emailService.sendEmail(emailBody);
          } catch (error) {
            console.log(error);
          }
          console.log(emailBody);
          console.log('mail enviado');
        } else {
          const toast = await this.toastCtrl.create({
            message: this.translate.instant(
              'EMAIL_NOT_SENT_DISALLOWED_BY_USER'
            ),
            duration: 3000,
            position: 'bottom',
          });
          toast.present();
        }
      });
  }

  async sendMailInviteCancelled(
    targetEmail: string,
    targetName: string,
    clubName: string
  ) {
    const emailBody = {
      template: this.translate.instant('GROUP_MAIL_TEMPLATE'),
      subject: this.translate.instant('GROUP_INVITE_CANCELLED_MAIL_SUBJECT'),
      to: [
        {
          name: targetName,
          email: targetEmail,
        },
      ],
      contexto: this.translate.instant('GROUP_INVITE_CANCELLED_MAIL_CONTEXT'),
      informacao: this.translate.instant(
        'GROUP_INVITE_CANCELLED_MAIL_INFORMATION'
      ),
      sender: '',
      mensagem: this.translate.instant('GROUP_INVITE_CANCELLED_MAIL_MESSAGE'),
      accao: this.translate.instant('GROUP_INVITE_CANCELLED_MAIL_ACTION'),
    };
    this.agentsService
      .agentAllowsMails(targetEmail, this.agentId.toString())
      .subscribe(async (allowMail) => {
        if (allowMail === true) {
          // this.emailService
          //   .sendEmail(emailBody)
          //   .subscribe((error) => console.log(error));

          try {
            await this.emailService.sendEmail(emailBody);
          } catch (error) {
            console.log(error);
          }
          console.log(emailBody);
          console.log('mail enviado');
        } else {
          const toast = await this.toastCtrl.create({
            message: this.translate.instant(
              'EMAIL_NOT_SENT_DISALLOWED_BY_USER'
            ),
            duration: 3000,
            position: 'bottom',
          });
          toast.present();
        }
      });
  }
  async sendMailRequestRefused(
    targetEmail: string,
    targetName: string,
    clubName: string
  ) {
    const emailBody = {
      template: this.translate.instant('GROUP_MAIL_TEMPLATE'),
      subject: this.translate.instant('GROUP_REQUEST_REFUSED_MAIL_SUBJECT'),
      to: [
        {
          name: targetName,
          email: targetEmail,
        },
      ],
      contexto: this.translate.instant('GROUP_REQUEST_REFUSED_MAIL_CONTEXT'),
      informacao: this.translate.instant(
        'GROUP_REQUEST_REFUSED_MAIL_INFORMATION'
      ),
      sender: '',
      mensagem: this.translate.instant('GROUP_REQUEST_REFUSED_MAIL_MESSAGE'),
      accao: this.translate.instant('GROUP_REQUEST_REFUSED_MAIL_ACTION'),
    };
    this.agentsService
      .agentAllowsMails(targetEmail, this.agentId.toString())
      .subscribe(async (allowMail) => {
        if (allowMail === true) {
          // this.emailService
          //   .sendEmail(emailBody)
          //   .subscribe((error) => console.log(error));

          try {
            await this.emailService.sendEmail(emailBody);
          } catch (error) {
            console.log(error);
          }
          console.log(emailBody);
          console.log('mail enviado');
        } else {
          const toast = await this.toastCtrl.create({
            message: this.translate.instant(
              'EMAIL_NOT_SENT_DISALLOWED_BY_USER'
            ),
            duration: 3000,
            position: 'bottom',
          });
          toast.present();
        }
      });
  }

  sendInvitationMail(
    targetEmail: string,
    senderName: string,
    groupName: string
  ) {
    const emailBody = {
      template: this.translate.instant('GROUP_MAIL_TEMPLATE'),
      subject: this.translate.instant('GROUP_INVITE_MAIL_SUBJECT'),
      to: [
        {
          name: targetEmail,
          email: targetEmail,
        },
      ],
      contexto: this.translate.instant('GROUP_INVITE_MAIL_CONTEXT') + groupName,
      informacao: this.translate.instant('GROUP_INVITE_MAIL_INFORMATION'),
      sender: senderName,
      mensagem: this.translate.instant('GROUP_INVITE_MAIL_MESSAGE'),
      accao: this.translate.instant('GROUP_INVITE_MAIL_ACTION'),
    };
    this.agentsService
      .agentAllowsMails(targetEmail, this.agentId.toString())
      .subscribe(async (allowMail) => {
        if (allowMail === true) {
          // this.emailService.sendEmail(emailBody).subscribe(
          //   async () => {
          //     const toast = await this.toastCtrl.create({
          //       message: this.translate.instant('EMAIL_SENT_TO_TARGET'),
          //       duration: 3000,
          //       position: 'bottom',
          //     });
          //     toast.present();
          //   },
          //   (error) => console.log(error)
          // );

          try {
            await this.emailService.sendEmail(emailBody);
            const toast = await this.toastCtrl.create({
              message: this.translate.instant('EMAIL_SENT_TO_TARGET'),
              duration: 3000,
              position: 'bottom',
            });
            toast.present();
          } catch (error) {
            console.log(error);
          }
          console.log(emailBody);
          console.log('mail enviado');
        } else {
          const toast = await this.toastCtrl.create({
            message: this.translate.instant(
              'EMAIL_NOT_SENT_DISALLOWED_BY_USER'
            ),
            duration: 3000,
            position: 'bottom',
          });
          toast.present();
        }
      });
  }

  getInvitedEmail(email) {
    if (this.groupDetails.STATUS === 4) {
      return email;
    } else {
      return this.translate.instant('INVITED');
    }
  }

  async inviteMembers(groupId: number, groupName: string) {
    if (this.isUserInternal(this.userEmail)) {
      const alrt = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant(
          'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
        ),
        buttons: [this.translate.instant('CONTINUE')],
      });
      alrt.present();
      return;
    }

    const alert = await this.alertCtrl.create({
      header: this.translate.instant('ADD_MEMBER_TITLE'),
      subHeader: this.translate.instant('ADD_MEMBER_SUBTITLE'),
      inputs: [
        {
          name: 'email',
          placeholder: this.translate.instant('INVITATION_EMAIL'),
        },
      ],
      buttons: [
        {
          text: this.translate.instant('ADD_ENTRY_CANCEL'),
          role: 'cancel',
          handler: (data) => {
            console.log('Cancel clicked');
          },
        },
        {
          text: this.translate.instant('ADD_MEMBER_BUTTON'),
          handler: (data) => {
            //            this.checkBeforeInviteSend(data.email, groupId,groupName)
            console.log(
              data.email + '-----' + groupId + '--------' + groupName
            );
            this.checkBeforeInviteSendMultiple(data.email, groupId, groupName);
          },
        },
      ],
      cssClass: 'alert-buttons',
    });
    alert.present();
  }
  async sendMessage(member: any) {
    console.log(member);
    if (member.AGENT_ID == null) {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant('STILL_NOT_EXME_USER'),
        duration: 3000,
        position: 'bottom',
      });
      toast.present();
      return;
    }
    if (this.isUserInternal(this.userEmail)) {
      const alrt = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant(
          'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
        ),
        buttons: [this.translate.instant('CONTINUE')],
      });
      alrt.present();
      return;
    }
    /*    this.agentsService.agentAllowsMails((member.CRM_AGENT_by_AGENT_ID)==null?member.EMAIL:member.CRM_AGENT_by_AGENT_ID.EMAIL).subscribe((allowMail) => {
              if ( allowMail == false  ) {
                let toast = this.toastCtrl.create({
                  message: this.translate.instant('EMAIL_DISALLOWED_BY_USER'),
                  duration: 3000,
                  position: 'bottom'
                });
                toast.present();
                return;
              } else {*/
    this.targetEmail =
      member.CRM_AGENT_by_AGENT_ID == null
        ? member.EMAIL
        : member.CRM_AGENT_by_AGENT_ID.EMAIL;
    this.targetName =
      member.CRM_AGENT_by_AGENT_ID == null
        ? member.EMAIL
        : member.CRM_AGENT_by_AGENT_ID.FIRST_NAME +
          ' ' +
          member.CRM_AGENT_by_AGENT_ID.LAST_NAME;
    console.log('target name is:' + this.targetName);
    //this.collectionAvatar = "";
    console.log(1);
    console.log('targetEmail:' + this.targetEmail);
    console.log('pushing language:' + this.language);

    let conversationId: number;
    //identificar se já há uma conversação

    try {
      const resp: any = await this.messageServices.getAgentsDirectConversation(
        this.agentId.toString(),
        member.AGENT_ID.toString()
      );
      console.log('getAgentsConversation response was:');
      console.log(resp);
      if (resp.resource.length > 0) {
        conversationId = resp.resource[0].conversation_id;
        const tmpVar: any = {
          agentId: this.agentId,
          conversationId,
          header:
            member.CRM_AGENT_by_AGENT_ID.FIRST_NAME +
            ' ' +
            member.CRM_AGENT_by_AGENT_ID.LAST_NAME,
        };
        this.router.navigate(['/chat/chat-conversation', tmpVar]);
      } else {
        console.log('creating conversation');

        try {
          const resp2: any = await this.messageServices.createConversation(
            'A',
            member.AGENT_ID
          );
          console.log('Trade conversation Response was:');
          console.log(resp2);
          conversationId = resp2.resource[0].conversation_id;

          try {
            const resp3 =
              await this.messageServices.associateAgentsToDirectOrTradeConversation(
                conversationId,
                this.agentId,
                member.AGENT_ID
              );
            console.log(
              'Associate Agents response was: ' + JSON.stringify(resp3)
            );

            const tmpVar: any = {
              agentId: this.agentId,
              conversationId,
              header:
                member.CRM_AGENT_by_AGENT_ID.FIRST_NAME +
                ' ' +
                member.CRM_AGENT_by_AGENT_ID.LAST_NAME,
            };
            this.router.navigate(['/chat/chat-conversation', tmpVar]);
          } catch (error) {}
        } catch (err) {
          console.log('Trade conversation error');
        }
      }
    } catch (error) {
      console.log('getAgentsConversation raised error. Error was:');
      console.log(error);
    }

    /*        let sendMessageModal = this.modalCtrl.create(ContactAgentPage,
                                                             {agentName: this.agentName,
                                                              language : this.language,
                                                              targetAgentName:this.targetName,
                                                              targetAgentEmail: this.targetEmail,
                                                              collection_avatar: "",
                                                              sourceEmail:this.userEmail});

                 sendMessageModal.onDidDismiss(
                  data => { } );
                 sendMessageModal.present();

        */
    /*      }
            })*/
  }

  async setFavorite(member: any) {
    console.log(member);
    // this.agentsService
    //   .getFavoriteStatus(this.agentId.toString(), member.AGENT_ID)
    //   .subscribe((resp: any) => {
    //     if (resp.resource.length > 0) {
    //       this.agentsService
    //         .setFavoriteStatus(this.agentId.toString(), member.AGENT_ID, 1)
    //         .subscribe((resp2) => {
    //           //item.is_favorite = is_favorite
    //           console.log('Resp Set received');
    //           console.log(resp2);
    //         });
    //     } else {
    //       this.agentsService
    //         .addFavoriteStatus(this.agentId.toString(), member.AGENT_ID, 1)
    //         .subscribe((resp2) => {
    //           //item.is_favorite = is_favorite
    //           console.log('Resp Add received');
    //           console.log(resp2);
    //         });
    //     }
    //   });

    try {
      const resp: any = await this.agentsService.getFavoriteStatus(
        this.agentId.toString(),
        member.AGENT_ID
      );
      if (resp.resource.length > 0) {
        // this.agentsService
        //   .setFavoriteStatus(this.agentId.toString(), member.AGENT_ID, 1)
        //   .subscribe((resp2) => {
        //     //item.is_favorite = is_favorite
        //     console.log('Resp Set received');
        //     console.log(resp2);
        //   });

        try {
          const resp2: any = await this.agentsService.setFavoriteStatus(
            this.agentId.toString(),
            member.AGENT_ID,
            1
          );
          //item.is_favorite = is_favorite
          console.log('Resp Set received');
          console.log(resp2);
        } catch (error) {
          console.log(error);
        }
      } else {
        // this.agentsService
        //   .addFavoriteStatus(this.agentId.toString(), member.AGENT_ID, 1)
        //   .subscribe((resp2) => {
        //     //item.is_favorite = is_favorite
        //     console.log('Resp Add received');
        //     console.log(resp2);
        //   });

        try {
          const resp2: any = await this.agentsService.addFavoriteStatus(
            this.agentId.toString(),
            member.AGENT_ID,
            1
          );
          //item.is_favorite = is_favorite
          console.log('Resp Add received');
          console.log(resp2);
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  async unsetFavorite(member: any) {
    console.log(member);
    // this.agentsService
    //   .getFavoriteStatus(this.agentId.toString(), member.AGENT_ID)
    //   .subscribe((resp: any) => {
    //     if (resp.resource.length > 0) {
    //       this.agentsService
    //         .setFavoriteStatus(this.agentId.toString(), member.AGENT_ID, 0)
    //         .subscribe((resp2) => {
    //           //item.is_favorite = is_favorite
    //           console.log('Resp Set received');
    //           console.log(resp2);
    //         });
    //     } else {
    //       this.agentsService
    //         .addFavoriteStatus(this.agentId.toString(), member.AGENT_ID, 0)
    //         .subscribe((resp2) => {
    //           //item.is_favorite = is_favorite
    //           console.log('Resp Add received');
    //           console.log(resp2);
    //         });
    //     }
    //   });

    try {
      const resp: any = await this.agentsService.getFavoriteStatus(
        this.agentId.toString(),
        member.AGENT_ID
      );
      if (resp.resource.length > 0) {
        // this.agentsService
        //   .setFavoriteStatus(this.agentId.toString(), member.AGENT_ID, 0)
        //   .subscribe((resp2) => {
        //     //item.is_favorite = is_favorite
        //     console.log('Resp Set received');
        //     console.log(resp2);
        //   });

        try {
          const resp2: any = await this.agentsService.setFavoriteStatus(
            this.agentId.toString(),
            member.AGENT_ID,
            0
          );
          //item.is_favorite = is_favorite
          console.log('Resp Set received');
          console.log(resp2);
        } catch (error) {
          console.log(error);
        }
      } else {
        // this.agentsService
        //   .addFavoriteStatus(this.agentId.toString(), member.AGENT_ID, 0)
        //   .subscribe((resp2) => {
        //     //item.is_favorite = is_favorite
        //     console.log('Resp Add received');
        //     console.log(resp2);
        //   });

        try {
          const resp2: any = await this.agentsService.addFavoriteStatus(
            this.agentId.toString(),
            member.AGENT_ID,
            0
          );
          //item.is_favorite = is_favorite
          console.log('Resp Add received');
          console.log(resp2);
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  getActionSheetButtons(member: any) {
    const a: any = [];
    if (member.STATUS === 3 || member.STATUS === 4) {
      a.push({
        text: this.translate.instant('SEND_MESSAGE'),
        handler: () => {
          this.sendMessage(member);
        },
      });
    }
    if (
      member.is_favorite === 0 &&
      (member.STATUS === 3 || member.STATUS === 4)
    ) {
      a.push({
        text: this.translate.instant('ADD_FAVORITE'),
        handler: () => {
          this.setFavorite(member);
          member.is_favorite = 1;
        },
      });
    }
    if (
      member.is_favorite === 1 &&
      (member.STATUS === 3 || member.STATUS === 4)
    ) {
      a.push({
        text: this.translate.instant('REMOVE_FAVORITE'),
        handler: () => {
          this.unsetFavorite(member);
          member.is_favorite = 0;
        },
      });
    }
    if (this.groupDetails.STATUS === 4) {
      a.push({
        text: this.translate.instant('MANAGE_MEMBER'),
        handler: () => {
          this.memberClick2(member);
        },
      });
    }
    if (this.groupDetails.STATUS === 4 && member.STATUS === 3) {
      a.push({
        text: this.translate.instant('PROMOTE_TO_ADMINISTRATOR'),
        handler: () => {
          this.promoteMemberToAdmin(member);
        },
      });
    }

    return a;
  }

  async memberClick(member) {
    console.log(member);
    console.log(this.agentId);
    if (member.AGENT_ID === this.agentId || this.inGroup === false) {
      return;
    }
    this.actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('MORE_OPTIONS'),
      buttons: this.getActionSheetButtons(member),
    });
    await this.actionSheet.present();
  }

  async promoteMemberToAdmin(member) {
    console.log('promoting member to Admin:');
    console.log(member);
    // this.groupServices
    //   .promoteMemberToAdmin(member.AGENT_ID, member.GROUP_ID, member.STATUS)
    //   .subscribe(
    //     async () => {
    //       console.log('member promoted');
    //       this.loadData();
    //       const toast = await this.toastCtrl.create({
    //         message: this.translate.instant('MEMBER_PROMOTED'),
    //         duration: 3000,
    //         position: 'bottom',
    //       });

    //       toast.present();
    //     },
    //     async (err) => {
    //       console.log('error');
    //       console.log(err);
    //       const toast = await this.toastCtrl.create({
    //         message: this.translate.instant('ERROR_PROMOTING_MEMBER'),
    //         duration: 3000,
    //         position: 'bottom',
    //       });

    //       toast.present();
    //     }
    //   );

    try {
      await this.groupServices.promoteMemberToAdmin(
        member.AGENT_ID,
        member.GROUP_ID,
        member.STATUS
      );
      console.log('member promoted');
      this.loadData();
      const toast = await this.toastCtrl.create({
        message: this.translate.instant('MEMBER_PROMOTED'),
        duration: 3000,
        position: 'bottom',
      });

      toast.present();
    } catch (err) {
      console.log('error');
      console.log(err);
      const toast = await this.toastCtrl.create({
        message: this.translate.instant('ERROR_PROMOTING_MEMBER'),
        duration: 3000,
        position: 'bottom',
      });

      toast.present();
    }
  }

  async memberClick2(member) {
    if (this.groupDetails.STATUS === 4) {
      if (member.STATUS === 1) {
        const alert = await this.alertCtrl.create({
          header: this.translate.instant('PROCESS_MEMBER_REQUEST_TITLE'),
          subHeader: this.translate.instant('PROCESS_MEMBER_REQUEST_SUBTITLE'),
          buttons: [
            {
              text: this.translate.instant('ACCEPT_MEMBER_BUTTON'),
              handler: (data) => {
                console.log('Pedido de entrada em Grupo Aceite');
                console.log('kkkkkk.....llllll - ' + JSON.stringify(member));
                this.updateAgentGroupStatus(
                  this.groupDetails.group_id,
                  member.AGENT_ID,
                  3,
                  'admin'
                );
                this.sendMailRequestAccepted(
                  member.CRM_AGENT_by_AGENT_ID.EMAIL,
                  member.CRM_AGENT_by_AGENT_ID.FIRST_NAME +
                    ' ' +
                    member.CRM_AGENT_by_AGENT_ID.LAST_NAME,
                  this.agentName,
                  this.groupDetails.Group_name
                );
                this.gds.evtRefreshBadgesValue(this.agentId);
                console.log('aaaaaaaaaaaabbbbbbbbbbbbbbb');
                void this.gaService.trackEvent('group_members_page', 'accept_member', 'success', 1);
                this.ads.evtShowInterstitialAdd('G');
                console.log('cccccccccccccdddddddddddddd');
              },
            },
            {
              text: this.translate.instant('REFUSE_MEMBER_BUTTON'),
              handler: (data) => {
                console.log('Pedido de entrada em Grupo Recusado');
                this.updateAgentGroupStatus(
                  this.groupDetails.group_id,
                  member.AGENT_ID,
                  -1,
                  'admin'
                );
                this.sendMailRequestRefused(
                  member.CRM_AGENT_by_AGENT_ID.EMAIL,
                  member.CRM_AGENT_by_AGENT_ID.FIRST_NAME,
                  this.groupDetails.Group_name
                );
                this.gds.evtRefreshBadgesValue(this.agentId);
                void this.gaService.trackEvent('group_members_page', 'refuse_member', 'success', 1);
                this.ads.evtShowInterstitialAdd('G');
              },
            },
            {
              text: this.translate.instant('ADD_ENTRY_CANCEL'),
              role: 'cancel',
              handler: (data) => {
                console.log('Cancel clicked');
              },
            },
          ],
          cssClass: 'alert-buttons',
        });
        alert.present();
      }

      if (member.STATUS === 2) {
        // Aguarda aprovação do membro... Manager pode cancelar pedido
        // Update member_group_status to -6

        const alert = await this.alertCtrl.create({
          header: this.translate.instant('CANCEL_ADMIN_INVITE_TITLE'),
          subHeader: this.translate.instant('CANCEL_ADMIN_INVITE_SUBTITLE'),
          buttons: [
            {
              text: this.translate.instant('CANCEL_INVITE_BUTTON'),
              handler: (data) => {
                console.log('Cancelamento de convite para entrada no grupo');
                if (member.AGENT_ID === undefined || member.AGENT_ID == null) {
                  //this.updateAgentGroupPendingStatus(this.groupDetails.group_id, member.email, -6, 'admin')
                  // não podemos aceder a CRM_AGENT_by_AGENT_ID porque é null
                  this.updateAgentGroupStatusByEmail(
                    this.groupDetails.group_id,
                    member.email,
                    -6,
                    'admin'
                  );
                } else {
                  this.updateAgentGroupStatus(
                    this.groupDetails.group_id,
                    member.AGENT_ID,
                    -6,
                    'admin'
                  );
                  this.sendMailInviteCancelled(
                    member.CRM_AGENT_by_AGENT_ID.EMAIL,
                    member.CRM_AGENT_by_AGENT_ID.FIRST_NAME,
                    this.groupDetails.Group_name
                  );
                }
                void this.gaService.trackEvent('group_members_page', 'cancel_member_invite', 'success', 1);
                this.ads.evtShowInterstitialAdd('G');
              },
            },
            {
              text: this.translate.instant('ADD_ENTRY_CANCEL'),
              role: 'cancel',
              handler: (data) => {
                console.log('Cancel clicked');
              },
            },
          ],
          cssClass: 'alert-buttons',
        });
        alert.present();
      }

      if (member.STATUS === 3) {
        // Está ativo... Pode ser expulso pelo Manager
        // Update member_group_status to -4

        const alert = await this.alertCtrl.create({
          header: this.translate.instant('KICKOUT_MEMBER_TITLE'),
          subHeader: this.translate.instant('KICKOUT_MEMBER_SUBTITLE'),
          buttons: [
            {
              text: this.translate.instant('KICKOUT_MEMBER_BUTTON'),
              handler: (data) => {
                console.log('Membro expulso do grupo');
                this.updateAgentGroupStatus(
                  this.groupDetails.group_id,
                  member.AGENT_ID,
                  -4,
                  'admin'
                );
                this.sendMailExpeledFromClub(
                  member.CRM_AGENT_by_AGENT_ID.EMAIL,
                  member.CRM_AGENT_by_AGENT_ID.FIRST_NAME,
                  this.groupDetails.Group_name
                );
                void this.gaService.trackEvent('group_members_page', 'kickout_member_invite', 'success', 1);
                this.ads.evtShowInterstitialAdd('G');
              },
            },
            {
              text: this.translate.instant('ADD_ENTRY_CANCEL'),
              role: 'cancel',
              handler: (data) => {
                console.log('Cancel clicked');
              },
            },
          ],
          cssClass: 'alert-buttons',
        });
        alert.present();
      }
    } else {
      //não é manager ... não pode efetuar alterações nos membros
    }
  }

  async deleteClub() {
    // TODO: Apagar Clube - CRM_GROUP e CRM_AGENT_GROUP
    // Temos um trigger na CRM_GROUP que quando o clube é desativado desactiva os CRM_AGENT_GROUPs e as relations.
    // TODO: Ou em vez de apagar adicionar coluna STATUS e "desativar"
    // campo é inactive
    if (this.isUserInternal(this.userEmail)) {
      const alrt = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant(
          'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
        ),
        buttons: [this.translate.instant('CONTINUE')],
      });
      alrt.present();
      return;
    }
    const alert = await this.alertCtrl.create({
      header: this.translate.instant('DELETE_GROUP_TITLE'),
      subHeader: this.translate.instant('DELETE_GROUP_SUBTITLE'),
      buttons: [
        {
          text: this.translate.instant('DELETE_GROUP'),
          handler: (data) => {
            //this.groupServices.deactivateGroup(this.agentId.toString(), this.groupDetails.group_id).subscribe(
            //  () => {
            //    if (this.platform.is('cordova')) {
            //      this.ga.trackEvent('group_members_page', 'delete_club', 'success', 1).then(() => {});
            //    }
            //  },
            //  (err) => {
            //    if (this.platform.is('cordova')) {
            //      this.ga.trackEvent('group_members_page', 'delete_club', 'success', 0).then(() => {});
            //    }
            //  }
            //);
            //this.ads.evtShowInterstitialAdd('G');

            this.groupServices
              .deactivateGroup(
                this.agentId.toString(),
                this.groupDetails.group_id
              )
              .then(() => {
                console.log('Group successfully deactivated.');

                void this.gaService.trackEvent('group_members_page', 'delete_club', 'success', 1);

                this.ads.evtShowInterstitialAdd('G');
              })
              .catch((err) => {
                console.log('Error deactivating group:', err);

                void this.gaService.trackEvent('group_members_page', 'delete_club', 'failure', 0);
              });
          },
        },
        {
          text: this.translate.instant('ADD_ENTRY_CANCEL'),
          role: 'cancel',
          handler: (data) => {
            console.log('Cancel clicked');
          },
        },
      ],
      cssClass: 'alert-buttons',
    });
    alert.present();
  }

  memberAcceptInvitation() {
    this.updateAgentGroupStatus(
      this.groupDetails.group_id,
      this.agentId,
      3,
      'member'
    );
    this.gds.evtRefreshBadgesValue(this.agentId);
  }

  memberRefuseInvitation() {
    this.updateAgentGroupStatus(
      this.groupDetails.group_id,
      this.agentId,
      -2,
      'member'
    );
    this.gds.evtRefreshBadgesValue(this.agentId);
  }

  async abandonClub() {
    console.log('groupDetails.STATUS: ', this.groupDetails.STATUS);

    if (this.groupDetails.STATUS === 4) {
      let countOtherAdmins = 0;
      // this.groupServices
      //   .getOtherAdmins(this.agentId.toString(), this.groupDetails.group_id)
      //   .subscribe(async (output: any) => {
      //     countOtherAdmins = output.resource.length;
      //     console.log(countOtherAdmins);
      //     if (countOtherAdmins === 0) {
      //       const alert = await this.alertCtrl.create({
      //         header: this.translate.instant(
      //           'CANNOT_LEAVE_WITHOUT_OTHER_ADMINS'
      //         ),
      //         subHeader: this.translate.instant(
      //           'CANNOT_LEAVE_WITHOUT_OTHER_ADMINS_SUBTITLE'
      //         ),
      //         buttons: [
      //           {
      //             text: 'OK',
      //             handler: (data) => {
      //               console.log('Clicked OK');
      //             },
      //           },
      //         ],
      //         cssClass: 'alert-buttons',
      //       });
      //       alert.present();
      //       return;
      //     }
      //     this.updateAgentGroupStatus(
      //       this.groupDetails.group_id,
      //       this.agentId,
      //       -3,
      //       'member'
      //     );
      //     this.gds.evtRefreshBadgesValue(this.agentId);
      //   });

      try {
        const output: any = await this.groupServices.getOtherAdmins(
          this.agentId.toString(),
          this.groupDetails.group_id
        );
        countOtherAdmins = output.resource.length;
        console.log(countOtherAdmins);
        if (countOtherAdmins === 0) {
          const alert = await this.alertCtrl.create({
            header: this.translate.instant('CANNOT_LEAVE_WITHOUT_OTHER_ADMINS'),
            subHeader: this.translate.instant(
              'CANNOT_LEAVE_WITHOUT_OTHER_ADMINS_SUBTITLE'
            ),
            buttons: [
              {
                text: 'OK',
                handler: (data) => {
                  console.log('Clicked OK');
                },
              },
            ],
            cssClass: 'alert-buttons',
          });
          alert.present();
          return;
        }
        this.updateAgentGroupStatus(
          this.groupDetails.group_id,
          this.agentId,
          -3,
          'member'
        );
        this.gds.evtRefreshBadgesValue(this.agentId);
      } catch (error) {}
    } else {
      this.updateAgentGroupStatus(
        this.groupDetails.group_id,
        this.agentId,
        -3,
        'member'
      );
      this.gds.evtRefreshBadgesValue(this.agentId);
    }
  }

  cancelJoinRequest() {
    this.updateAgentGroupStatus(
      this.groupDetails.group_id,
      this.agentId,
      -5,
      'member'
    );
    this.gds.evtRefreshBadgesValue(this.agentId);
  }

  async updateAgentGroupStatus(
    group: number,
    agent: string,
    status: number,
    who: string
  ) {
    // this.groupServices
    //   .updateAgentGroupStatus(group.toString(), agent.toString(), status)
    //   .subscribe(
    //     () => {
    //       this.showToast(status, who);
    //       this.loadData();
    //       //this.groupDetails.STATUS = status
    //     },
    //     (err) => {
    //       console.log('Erro a atualizar estado');
    //     }
    //   );

    try {
      await this.groupServices.updateAgentGroupStatus(
        group.toString(),
        agent.toString(),
        status
      );
      this.showToast(status, who);
      this.loadData();
      //this.groupDetails.STATUS = status
    } catch (error) {
      console.log('Erro a atualizar estado');
    }
  }
  async updateAgentGroupStatusByEmail(
    group: number,
    email: string,
    status: number,
    who: string
  ) {
    // this.groupServices
    //   .updateAgentGroupStatusByEmail(group.toString(), email, status)
    //   .subscribe(
    //     () => {
    //       this.showToast(status, who);
    //       this.loadData();
    //       //this.groupDetails.STATUS = status
    //     },
    //     (err) => {
    //       console.log('Erro a atualizar estado');
    //     }
    //   );

    try {
      await this.groupServices.updateAgentGroupStatusByEmail(
        group.toString(),
        email,
        status
      );
      this.showToast(status, who);
      this.loadData();
      //this.groupDetails.STATUS = status
    } catch (error) {
      console.log('Erro a atualizar estado');
    }
  }

  async updateAgentGroupPendingStatus(
    group: number,
    mail: string,
    status: number,
    who: string
  ) {
    // this.groupServices
    //   .updateAgentGroupPendingStatus(group.toString(), mail, status)
    //   .subscribe(
    //     () => {
    //       this.showToast(status, who);
    //       this.loadData();
    //       this.groupDetails.STATUS = status;
    //     },
    //     (err) => {
    //       console.log('Erro a atualizar estado');
    //     }
    //   );

    try {
      await this.groupServices.updateAgentGroupPendingStatus(
        group.toString(),
        mail,
        status
      );
    } catch (error) {
      console.log('Erro a atualizar estado');
    }
  }

  showToast(status, who) {
    if (status === 2 && who === 'admin') {
      this.presentToast(this.translate.instant('INVITE_SEND_TOAST_MSG'), false);
      this.getGroupMembers();
    }
    if (status === 3 && who === 'admin') {
      this.presentToast(this.translate.instant('MEMBER_ADD_TOAST_MSG'), false);
      this.getGroupMembers();
    }
    if (status === 3 && who === 'member') {
      this.presentToast(this.translate.instant('JOINED_CLUB_TOAST_MSG'), false);
      this.getGroupMembers();
    }
    if (status === -1 && who === 'admin') {
      this.presentToast(
        this.translate.instant('REQUEST_REFUSED_TOAST_MSG'),
        false
      );
      this.getGroupMembers();
    }
    if (status === -2 && who === 'member') {
      this.presentToast(
        this.translate.instant('INVITE_REFUSED_TOAST_MSG'),
        true
      );
    }
    if (status === -3 && who === 'member') {
      this.presentToast(this.translate.instant('CLUB_EXIT_TOAST_MSG'), true);
    }
    if (status === -4 && who === 'admin') {
      this.presentToast(
        this.translate.instant('CLUB_KICKOUT_TOAST_MSG'),
        false
      );
      this.getGroupMembers();
    }
    if (status === -5 && who === 'member') {
      this.presentToast(
        this.translate.instant('JOIN_REQ_CANCEL_TOAST_MSG'),
        true
      );
    }
    if (status === -6 && who === 'admin') {
      this.presentToast(
        this.translate.instant('JOIN_INVITE_CANCEL_TOAST_MSG'),
        false
      );
      this.getGroupMembers();
    }
  }

  async presentToast(message: string, pop: boolean, color?: string) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      position: 'bottom',
      color: color || 'primary',
    });

    toast.onDidDismiss().then(() => {
      if (pop) {
        this.router.navigateByUrl('/clubs');
      }
    });

    toast.present();
  }

  isUserInternal(email: string) {
    if (
      email === 'ExMEAnonymousAccount@exme.club' ||
      email === 'ExMEAnonymousAccount2@exme.club'
    ) {
      return true;
    }
    return false;
  }

  async changePicture() {
    console.log('In changePicture for ' + this.userEmail);
    if (this.isUserInternal(this.userEmail)) {
      const alrt2 = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant(
          'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
        ),
        buttons: [this.translate.instant('CONTINUE')],
      });
      alrt2.present();
      return;
    }
    const alrt = await this.alertCtrl.create({
      header: this.translate.instant('CHANGE_PIC_TITLE'),
      message: this.translate.instant('CHANGE_PIC_MESSAGE'),
      buttons: [
        {
          text: this.translate.instant('CHANGE_PIC_USE_CAM'),
          handler: (data) => {
            this.takePicture();
          },
        },
        {
          text: this.translate.instant('CHANGE_PIC_USE_BIB'),
          handler: (data) => {
            this.choosePicture();
          },
        },
      ],
      cssClass: 'alert-buttons',
    });
    alrt.present();
  }

  async onFileChange(event) {
    console.log('on file Change');
    if (this.isUserInternal(this.userEmail)) {
      const alrt = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant(
          'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
        ),
        buttons: [this.translate.instant('CONTINUE')],
      });
      alrt.present();
      return;
    }
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.uploadFile(String(reader.result).split(',')[1]);
      };
    }
  }

  async uploadFile(imageData: any) {
    console.log('In uploadFile');
    if (this.isUserInternal(this.userEmail)) {
      const alrt = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant(
          'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
        ),
        buttons: [this.translate.instant('CONTINUE')],
      });
      alrt.present();
      return;
    }

    const today = new Date();
    const date =
      today.getFullYear() + '' + (today.getMonth() + 1) + today.getDate();
    const time =
      '' + today.getHours() + today.getMinutes() + today.getSeconds();
    const dateTime = date + time;
    const logoFileName =
      'logo_' + this.groupDetails.group_id + '_' + dateTime + '.png';

    // this.fileServices.loadGroupLogo(imageData, logoFileName).subscribe(
    //   () => {
    //     console.log('Ficheiro carregado');
    //     const groupLogoURL =
    //       environment.apiUrl +
    //       common.groupLogoLocation +
    //       logoFileName +
    //       '?api_key=' +
    //       // environment.fileManagerAPIKey +
    //       '&session_token=';
    //     //                        this.showUploadToast(true, 'Upload successful')
    //     this.groupDetails.LOGO = groupLogoURL;
    //     this.saveLogoUrl(groupLogoURL);
    //     if (this.platform.is('cordova')) {
    //       this.ga
    //         .trackEvent('group_members_page', 'change_group_logo', 'success', 1)
    //         .then(() => {});
    //     }
    //   },
    //   (err) => {
    //     console.log('Erro ao upload ficheiro');
    //     this.showUploadToast(
    //       false,
    //       this.translate.instant('GROUP_IMAGE_LOAD_FAILURE')
    //     );
    //     if (this.platform.is('cordova')) {
    //       this.ga
    //         .trackEvent('group_members_page', 'change_group_logo', 'success', 0)
    //         .then(() => {});
    //     }
    //   }
    // );
  }

  async showUploadToast(ok: boolean, message: string) {
    if (ok) {
      const toast = await this.toastCtrl.create({
        message,
        duration: 3000,
        position: 'bottom',
      });
      toast.present();
    } else {
      const toast = await this.toastCtrl.create({
        message,
        duration: 3000,
        position: 'bottom',
      });
      toast.present();
    }
  }

  async takePicture() {
    console.log('In takePicture');
    if (this.isUserInternal(this.userEmail)) {
      const alrt = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant(
          'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
        ),
        buttons: [this.translate.instant('CONTINUE')],
      });
      alrt.present();
      return;
    }

    const image = await Camera.getPhoto({
      quality: 20,
      allowEditing: true,
      source: CameraSource.Camera,
      width: 300,
      height: 300,
      resultType: CameraResultType.Base64,
    });

    const image2Load = image.base64String;

    this.uploadFile(image2Load);
  }

  async choosePicture() {
    console.log('In choosePicture');
    if (this.isUserInternal(this.userEmail)) {
      const alrt = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant(
          'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
        ),
        buttons: [this.translate.instant('CONTINUE')],
      });
      alrt.present();
      return;
    }

    const image = await Camera.getPhoto({
      quality: 20,
      allowEditing: true,
      source: CameraSource.Photos,
      width: 300,
      height: 300,
      resultType: CameraResultType.Base64,
    });

    const image2Load = image.base64String;

    this.uploadFile(image2Load);
  }

  async saveLogoUrl(groupLogoURL: string) {
    console.log('seria aqui gravado a url do ficheiro' + groupLogoURL);
    // this.groupServices
    //   .updateGroupLogo(this.groupDetails.group_id, groupLogoURL)
    //   .subscribe(
    //     () => {
    //       this.presentToast(
    //         this.translate.instant('CLUB_UPDATED_SUCCESSFULLY'),
    //         false
    //       );
    //     },
    //     (error) =>
    //       this.presentToast(this.translate.instant('CLUB_UPDATE_FAILED'), false)
    //   );

    try {
      await this.groupServices.updateGroupLogo(
        this.groupDetails.group_id,
        groupLogoURL
      );
      this.presentToast(
        this.translate.instant('CLUB_UPDATED_SUCCESSFULLY'),
        false
      );
    } catch (error) {
      this.presentToast(this.translate.instant('CLUB_UPDATE_FAILED'), false);
    }
  }

  async joinPublicGroup(group) {
    if (this.isUserInternal(this.userEmail)) {
      const alrt = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant(
          'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
        ),
        buttons: [this.translate.instant('CONTINUE')],
      });
      alrt.present();
      return;
    }

    const alert = await this.alertCtrl.create({
      header: group.Group_name,
      subHeader: this.translate.instant('JOIN_PUBLIC_GROUP_MSG'),
      buttons: [
        {
          text: this.translate.instant('ADD_ENTRY_CANCEL'),
          role: 'cancel',
          handler: (data) => {
            console.log('Cancel clicked');
          },
        },
        {
          text: this.translate.instant('JOIN_GROUP'),
          handler: (data) => {
            this.addAgentToGroup(
              group.group_id,
              this.agentId,
              group.Group_name,
              group.group_description,
              group.manager_email,
              'public'
            );
            this.router.navigateByUrl('/clubs');
          },
        },
      ],
      cssClass: 'alert-buttons',
    });
    alert.present();
  }

  async joinPrivateGroup(group) {
    console.log('In joinPrivateGroup');
    if (this.isUserInternal(this.userEmail)) {
      const alrt = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant(
          'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
        ),
        buttons: [this.translate.instant('CONTINUE')],
      });
      alrt.present();
      return;
    }

    const alert = await this.alertCtrl.create({
      header: group.Group_name,
      subHeader: this.translate.instant('JOIN_PRIVATE_GROUP_MSG'),
      buttons: [
        {
          text: this.translate.instant('ADD_ENTRY_CANCEL'),
          role: 'cancel',
          handler: (data) => {
            console.log('Cancel clicked');
          },
        },
        {
          text: this.translate.instant('JOIN_GROUP'),
          handler: async (data) => {
            console.log('processing group entry for private group. Group is:');
            console.log(group);
            // this.groupServices.getGroupAdmins(group.group_id).subscribe(
            //   (adminList: any) => {
            //     console.log('admin list retrieved');
            //     console.log(adminList);
            //     let row: number;
            //     row = 1;
            //     console.log("before addAgentToGroup");
            //     for (const admin of adminList.resource) {
            //       this.addAgentToGroup(
            //         group.group_id,
            //         this.agentId,
            //         group.Group_name,
            //         group.group_description,
            //         admin.email,
            //         'private'
            //       );
            //       row = row + 1;
            //     }
            //   },
            //   (error) => {
            //     console.log(error);
            //     this.router.navigateByUrl('/clubs');
            //   }
            // );

            this.addAgentToGroup(
              group.group_id,
              this.agentId,
              group.Group_name,
              group.group_description,
              group.manager_email,
              'private'
            );

            this.router.navigateByUrl('/clubs');
          },
        },
      ],
      cssClass: 'alert-buttons',
    });
    alert.present();
  }

  async addAgentToGroup(
    groupId,
    agentId,
    groupName,
    groupDescription,
    manager_email,
    groupType
  ) {
    console.log('In addAgentToGroup');
    let toastMessage = this.translate.instant('EMAIL_SEND_TOAST_MESSAGE');
    if (groupType === 'public') {
      toastMessage = 'Parabéns, já pertences ao clube ' + groupName;
    }

    if (this.isUserInternal(this.userEmail)) {
      const alrt = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant(
          'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
        ),
        buttons: [this.translate.instant('CONTINUE')],
      });
      alrt.present();
      return;
    }
    console.log('adding to Group');
    //this.groupServices.callProcToAddAgentToGroup(groupId, agentId)
    //  .subscribe ( async () => {
    //    if (this.platform.is('cordova')) {
    //      this.ga.trackEvent('groups_list_page', 'add_agent_to_group', 'success', 1).then(() => {});
    //    }
    //    this.ads.evtShowInterstitialAdd('G');
    //    if (groupType === 'private') {
    //      //this.sendEntryRequestMail(manager_email, this.agentEmail, groupName);
    //      this.sendEntryRequestMail(manager_email, this.agent.FIRST_NAME + ' ' + this.agent.LAST_NAME, groupName);
    //    }
    //    const toast = await this.toastCtrl.create({
    //      message: toastMessage,
    //      duration: 3000,
    //      position: 'bottom'
    //    });
    //    toast.present();
    //  }, (err) => {
    //    if (this.platform.is('cordova')) {
    //      this.ga.trackEvent('groups_list_page', 'add_agent_to_group', 'success', 0).then(() => {});
    //    }
    //  }
    //  );

    this.groupServices
      .callProcToAddAgentToGroup(groupId, agentId)
      .then(async () => {
        void this.gaService.trackEvent('groups_list_page', 'add_agent_to_group', 'success', 1);
        this.ads.evtShowInterstitialAdd('G');

        if (groupType === 'private') {
          this.sendEntryRequestMail(
            manager_email,
            this.agent.FIRST_NAME + ' ' + this.agent.LAST_NAME,
            groupName
          );
        }

        const toast = await this.toastCtrl.create({
          message: toastMessage,
          duration: 3000,
          position: 'bottom',
        });
        toast.present();
      })
      .catch((err) => {
        console.error('Error adding agent to group:', err);
        void this.gaService.trackEvent('groups_list_page', 'add_agent_to_group', 'failure', 0);
      });
  }

  sendEntryRequestMail(
    targetEmail: string,
    senderName: string,
    groupName: string
  ) {
    const emailBody = {
      template: this.translate.instant('GROUP_MAIL_TEMPLATE'),
      subject: this.translate.instant('GROUP_PRIV_REQUEST_MAIL_SUBJECT'),
      to: [
        {
          name: targetEmail,
          email: targetEmail,
        },
      ],
      contexto: this.translate.instant('GROUP_PRIV_REQUEST_MAIL_CONTEXT'),
      informacao: this.translate.instant('GROUP_PRIV_REQUEST_MAIL_INFORMATION'),
      sender: senderName,
      mensagem: this.translate.instant('GROUP_PRIV_REQUEST_MAIL_MESSAGE'),
      accao: this.translate.instant('GROUP_PRIV_REQUEST_MAIL_ACTION'),
    };
    this.agentsService
      .agentAllowsMails(targetEmail, this.agentId.toString())
      .subscribe(async (allowMail) => {
        if (allowMail === true) {
          // this.emailService
          //   .sendEmail(emailBody)
          //   .subscribe((error) => console.log(error));

          try {
            await this.emailService.sendEmail(emailBody);
          } catch (error) {
            console.log(error);
          }
          console.log(emailBody);
          console.log('mail enviado');
        } else {
          const toast = await this.toastCtrl.create({
            message: this.translate.instant(
              'EMAIL_NOT_SENT_DISALLOWED_BY_USER'
            ),
            duration: 3000,
            position: 'bottom',
          });
          toast.present();
        }
      });
  }

  async goToMessages() {
    console.log('going to Group Messages');
    console.log(this.groupDetails);
    //check if group has conversation ID
    if (
      this.groupDetails.group_message_conversation_id === null ||
      this.groupDetails.group_message_conversation_id === 'null'
    ) {
      // this.messageServices
      //   .createGroupConversation(this.groupDetails.group_id)
      //   .subscribe(
      //     async (resp: any) => {
      //       console.log('Response was:');
      //       console.log(resp);
      //       this.groupDetails.group_message_conversation_id =
      //         resp.resource[0].conversation_id;
      //       // this.messageServices
      //       //   .getAgentConversationLastRead(
      //       //     this.groupDetails.group_message_conversation_id,
      //       //     this.agentId.toString()
      //       //   )
      //       //   .subscribe(
      //       //     async (resp1: any) => {
      //       //       if (resp1.resource.length === 0) {
      //       //         // this.messageServices
      //       //         //   .associateAgentToGroupConversation(
      //       //         //     this.groupDetails.group_message_conversation_id,
      //       //         //     this.agentId.toString(),
      //       //         //     this.groupDetails.group_id
      //       //         //   )
      //       //         //   .subscribe(
      //       //         //     (resp2) => {
      //       //         //       console.log(
      //       //         //         'Agent Associated with Group Conversation'
      //       //         //       );
      //       //         //       const tmpVar: any = {
      //       //         //         agentId: this.agentId,
      //       //         //         conversationId:
      //       //         //           this.groupDetails.group_message_conversation_id,
      //       //         //         header: this.groupDetails.Group_name,
      //       //         //       };
      //       //         //       console.log('Parameters are:');
      //       //         //       console.log(tmpVar);
      //       //         //       this.router.navigate([
      //       //         //         '/chat/chat-conversation',
      //       //         //         tmpVar,
      //       //         //       ]);
      //       //         //     },
      //       //         //     (err) => {
      //       //         //       console.log('error');
      //       //         //       console.log(err);
      //       //         //     }
      //       //         //   );

      //       //         try {
      //       //           const resp2: any = await this.messageServices.associateAgentToGroupConversation(this.groupDetails.group_message_conversation_id,this.agentId.toString(),this.groupDetails.group_id);
      //       //           console.log(
      //       //             'Agent Associated with Group Conversation'
      //       //           );
      //       //           const tmpVar: any = {
      //       //             agentId: this.agentId,
      //       //             conversationId:
      //       //               this.groupDetails.group_message_conversation_id,
      //       //             header: this.groupDetails.Group_name,
      //       //           };
      //       //           console.log('Parameters are:');
      //       //           console.log(tmpVar);
      //       //           this.router.navigate([
      //       //             '/chat/chat-conversation',
      //       //             tmpVar,
      //       //           ]);
      //       //         } catch (error) {
      //       //           console.log('error');
      //       //           console.log(error);
      //       //         }
      //       //       } else {
      //       //         const tmpVar: any = {
      //       //           agentId: this.agentId,
      //       //           conversationId:
      //       //             this.groupDetails.group_message_conversation_id,
      //       //           header: this.groupDetails.Group_name,
      //       //         };
      //       //         console.log('Parameters are:');
      //       //         console.log(tmpVar);
      //       //         this.router.navigate(['/chat/chat-conversation', tmpVar]);
      //       //       }
      //       //     },
      //       //     (err) => {
      //       //       console.log('error');
      //       //       console.log(err);
      //       //     }
      //       //   );

      //       try {
      //         const resp1: any = await this.messageServices.getAgentConversationLastRead(this.groupDetails.group_message_conversation_id,this.agentId.toString());
      //         if (resp1.resource.length === 0) {
      //           // this.messageServices
      //           //   .associateAgentToGroupConversation(
      //           //     this.groupDetails.group_message_conversation_id,
      //           //     this.agentId.toString(),
      //           //     this.groupDetails.group_id
      //           //   )
      //           //   .subscribe(
      //           //     (resp2) => {
      //           //       console.log(
      //           //         'Agent Associated with Group Conversation'
      //           //       );
      //           //       const tmpVar: any = {
      //           //         agentId: this.agentId,
      //           //         conversationId:
      //           //           this.groupDetails.group_message_conversation_id,
      //           //         header: this.groupDetails.Group_name,
      //           //       };
      //           //       console.log('Parameters are:');
      //           //       console.log(tmpVar);
      //           //       this.router.navigate([
      //           //         '/chat/chat-conversation',
      //           //         tmpVar,
      //           //       ]);
      //           //     },
      //           //     (err) => {
      //           //       console.log('error');
      //           //       console.log(err);
      //           //     }
      //           //   );

      //           try {
      //             const resp2: any = await this.messageServices.associateAgentToGroupConversation(this.groupDetails.group_message_conversation_id,this.agentId.toString(),this.groupDetails.group_id);
      //             console.log(
      //               'Agent Associated with Group Conversation'
      //             );
      //             const tmpVar: any = {
      //               agentId: this.agentId,
      //               conversationId:
      //                 this.groupDetails.group_message_conversation_id,
      //               header: this.groupDetails.Group_name,
      //             };
      //             console.log('Parameters are:');
      //             console.log(tmpVar);
      //             this.router.navigate([
      //               '/chat/chat-conversation',
      //               tmpVar,
      //             ]);
      //           } catch (error) {
      //             console.log('error');
      //             console.log(error);
      //           }
      //         } else {
      //           const tmpVar: any = {
      //             agentId: this.agentId,
      //             conversationId:
      //               this.groupDetails.group_message_conversation_id,
      //             header: this.groupDetails.Group_name,
      //           };
      //           console.log('Parameters are:');
      //           console.log(tmpVar);
      //           this.router.navigate(['/chat/chat-conversation', tmpVar]);
      //         }
      //       } catch (error) {
      //         console.log('error');
      //         console.log(error);
      //       }
      //     },
      //     (err) => {
      //       console.log('error');
      //     }
      //   );

      try {
        const resp: any = await this.messageServices.createGroupConversation(
          this.groupDetails.group_id
        );
        console.log('Response was:');
        console.log(resp);
        this.groupDetails.group_message_conversation_id =
          resp.resource[0].conversation_id;
        // this.messageServices
        //   .getAgentConversationLastRead(
        //     this.groupDetails.group_message_conversation_id,
        //     this.agentId.toString()
        //   )
        //   .subscribe(
        //     async (resp1: any) => {
        //       if (resp1.resource.length === 0) {
        //         // this.messageServices
        //         //   .associateAgentToGroupConversation(
        //         //     this.groupDetails.group_message_conversation_id,
        //         //     this.agentId.toString(),
        //         //     this.groupDetails.group_id
        //         //   )
        //         //   .subscribe(
        //         //     (resp2) => {
        //         //       console.log(
        //         //         'Agent Associated with Group Conversation'
        //         //       );
        //         //       const tmpVar: any = {
        //         //         agentId: this.agentId,
        //         //         conversationId:
        //         //           this.groupDetails.group_message_conversation_id,
        //         //         header: this.groupDetails.Group_name,
        //         //       };
        //         //       console.log('Parameters are:');
        //         //       console.log(tmpVar);
        //         //       this.router.navigate([
        //         //         '/chat/chat-conversation',
        //         //         tmpVar,
        //         //       ]);
        //         //     },
        //         //     (err) => {
        //         //       console.log('error');
        //         //       console.log(err);
        //         //     }
        //         //   );

        //         try {
        //           const resp2: any = await this.messageServices.associateAgentToGroupConversation(this.groupDetails.group_message_conversation_id,this.agentId.toString(),this.groupDetails.group_id);
        //           console.log(
        //             'Agent Associated with Group Conversation'
        //           );
        //           const tmpVar: any = {
        //             agentId: this.agentId,
        //             conversationId:
        //               this.groupDetails.group_message_conversation_id,
        //             header: this.groupDetails.Group_name,
        //           };
        //           console.log('Parameters are:');
        //           console.log(tmpVar);
        //           this.router.navigate([
        //             '/chat/chat-conversation',
        //             tmpVar,
        //           ]);
        //         } catch (error) {
        //           console.log('error');
        //           console.log(error);
        //         }
        //       } else {
        //         const tmpVar: any = {
        //           agentId: this.agentId,
        //           conversationId:
        //             this.groupDetails.group_message_conversation_id,
        //           header: this.groupDetails.Group_name,
        //         };
        //         console.log('Parameters are:');
        //         console.log(tmpVar);
        //         this.router.navigate(['/chat/chat-conversation', tmpVar]);
        //       }
        //     },
        //     (err) => {
        //       console.log('error');
        //       console.log(err);
        //     }
        //   );

        try {
          const resp1: any =
            await this.messageServices.getAgentConversationLastRead(
              this.groupDetails.group_message_conversation_id,
              this.agentId.toString()
            );
          if (resp1.resource.length === 0) {
            // this.messageServices
            //   .associateAgentToGroupConversation(
            //     this.groupDetails.group_message_conversation_id,
            //     this.agentId.toString(),
            //     this.groupDetails.group_id
            //   )
            //   .subscribe(
            //     (resp2) => {
            //       console.log(
            //         'Agent Associated with Group Conversation'
            //       );
            //       const tmpVar: any = {
            //         agentId: this.agentId,
            //         conversationId:
            //           this.groupDetails.group_message_conversation_id,
            //         header: this.groupDetails.Group_name,
            //       };
            //       console.log('Parameters are:');
            //       console.log(tmpVar);
            //       this.router.navigate([
            //         '/chat/chat-conversation',
            //         tmpVar,
            //       ]);
            //     },
            //     (err) => {
            //       console.log('error');
            //       console.log(err);
            //     }
            //   );

            try {
              const resp2: any =
                await this.messageServices.associateAgentToGroupConversation(
                  this.groupDetails.group_message_conversation_id,
                  this.agentId.toString(),
                  this.groupDetails.group_id
                );
              console.log('Agent Associated with Group Conversation');
              const tmpVar: any = {
                agentId: this.agentId,
                conversationId: this.groupDetails.group_message_conversation_id,
                header: this.groupDetails.Group_name,
              };
              console.log('Parameters are:');
              console.log(tmpVar);
              this.router.navigate(['/chat/chat-conversation', tmpVar]);
            } catch (error) {
              console.log('error');
              console.log(error);
            }
          } else {
            const tmpVar: any = {
              agentId: this.agentId,
              conversationId: this.groupDetails.group_message_conversation_id,
              header: this.groupDetails.Group_name,
            };
            console.log('Parameters are:');
            console.log(tmpVar);
            this.router.navigate(['/chat/chat-conversation', tmpVar]);
          }
        } catch (error) {
          console.log('error');
          console.log(error);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      // push message view for group conversation
      // this.messageServices
      //   .getAgentConversationLastRead(
      //     this.groupDetails.group_message_conversation_id,
      //     this.agentId.toString()
      //   )
      //   .subscribe(
      //     async (resp: any) => {
      //       if (resp.resource.length === 0) {
      //         // this.messageServices
      //         //   .associateAgentToGroupConversation(
      //         //     this.groupDetails.group_message_conversation_id,
      //         //     this.agentId.toString(),
      //         //     this.groupDetails.group_id
      //         //   )
      //         //   .subscribe(
      //         //     (resp2) => {
      //         //       console.log('Agent Associated with Group Conversation');
      //         //       const tmpVar: any = {
      //         //         agentId: this.agentId,
      //         //         conversationId:
      //         //           this.groupDetails.group_message_conversation_id,
      //         //         header: this.groupDetails.Group_name,
      //         //       };
      //         //       console.log('Parameters are:');
      //         //       console.log(tmpVar);
      //         //       this.router.navigate(['/chat/chat-conversation', tmpVar]);
      //         //     },
      //         //     (err) => {
      //         //       console.log('error');
      //         //       console.log(err);
      //         //     }
      //         //   );

      //         try {
      //           const resp2: any = await this.messageServices
      //           .associateAgentToGroupConversation(this.groupDetails.group_message_conversation_id,this.agentId.toString(),this.groupDetails.group_id);
      //           console.log('Agent Associated with Group Conversation');
      //           const tmpVar: any = {
      //             agentId: this.agentId,
      //             conversationId:
      //               this.groupDetails.group_message_conversation_id,
      //             header: this.groupDetails.Group_name,
      //           };
      //           console.log('Parameters are:');
      //           console.log(tmpVar);
      //           this.router.navigate(['/chat/chat-conversation', tmpVar]);
      //         } catch (error) {
      //           console.log('error');
      //           console.log(error);
      //         }
      //       } else {
      //         const tmpVar: any = {
      //           agentId: this.agentId,
      //           conversationId: this.groupDetails.group_message_conversation_id,
      //           header: this.groupDetails.Group_name,
      //         };
      //         console.log('Parameters are:');
      //         console.log(tmpVar);
      //         this.router.navigate(['/chat/chat-conversation', tmpVar]);
      //       }
      //     },
      //     (err) => {
      //       console.log('error');
      //       console.log(err);
      //     }
      //   );

      try {
        const resp: any =
          await this.messageServices.getAgentConversationLastRead(
            this.groupDetails.group_message_conversation_id,
            this.agentId.toString()
          );
        if (resp.resource.length === 0) {
          // this.messageServices
          //   .associateAgentToGroupConversation(
          //     this.groupDetails.group_message_conversation_id,
          //     this.agentId.toString(),
          //     this.groupDetails.group_id
          //   )
          //   .subscribe(
          //     (resp2) => {
          //       console.log('Agent Associated with Group Conversation');
          //       const tmpVar: any = {
          //         agentId: this.agentId,
          //         conversationId:
          //           this.groupDetails.group_message_conversation_id,
          //         header: this.groupDetails.Group_name,
          //       };
          //       console.log('Parameters are:');
          //       console.log(tmpVar);
          //       this.router.navigate(['/chat/chat-conversation', tmpVar]);
          //     },
          //     (err) => {
          //       console.log('error');
          //       console.log(err);
          //     }
          //   );

          try {
            const resp2: any =
              await this.messageServices.associateAgentToGroupConversation(
                this.groupDetails.group_message_conversation_id,
                this.agentId.toString(),
                this.groupDetails.group_id
              );
            console.log('Agent Associated with Group Conversation');
            const tmpVar: any = {
              agentId: this.agentId,
              conversationId: this.groupDetails.group_message_conversation_id,
              header: this.groupDetails.Group_name,
            };
            console.log('Parameters are:');
            console.log(tmpVar);
            this.router.navigate(['/chat/chat-conversation', tmpVar]);
          } catch (error) {
            console.log('error');
            console.log(error);
          }
        } else {
          const tmpVar: any = {
            agentId: this.agentId,
            conversationId: this.groupDetails.group_message_conversation_id,
            header: this.groupDetails.Group_name,
          };
          console.log('Parameters are:');
          console.log(tmpVar);
          this.router.navigate(['/chat/chat-conversation', tmpVar]);
        }
      } catch (error) {
        console.log('error');
        console.log(error);
      }
    }
  }

  async exitGroupAlert() {
    const EXIT = this.translate.instant('EXIT_CLUB');
    const EXIT_TEXT = this.translate.instant('EXIT_CLUB_TEXT');

    const alert = await this.alertCtrl.create({
      message: EXIT_TEXT,
      buttons: [
        {
          text: EXIT,
          handler: (data) => {
            this.abandonClub();
          },
        },
        {
          text: this.translate.instant('ADD_ENTRY_CANCEL'),
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          },
        },
      ],
      cssClass: 'alert-buttons',
    });
    alert.present();
  }

  radioBtnSave() {
    // Clear the previous timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    // Set a new timeout for saving agent
    this.debounceTimeout = setTimeout(() => {
      this.saveClubChanges(this.groupDetails.group_id);

      // Set debounceReady to false for 1 second after saving
      this.debounceReady = false;

      // Reset debounceReady back to true after 1 second
      setTimeout(() => {
        this.debounceReady = true;
      }, 1000);
    }, 2000);
  }

  onInputChange() {
    // Clear the previous timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    // Set a new timeout for saving agent
    this.debounceTimeout = setTimeout(() => {
      this.saveClubChanges(this.groupDetails.group_id);

      // Set debounceReady to false for 1 second after saving
      this.debounceReady = false;

      // Reset debounceReady back to true after 1 second
      setTimeout(() => {
        this.debounceReady = true;
      }, 1000);
    }, 2000);
  }
}
